import { styled } from "@mui/material";

export const StyledListbox = styled("ul")`
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: ${({ theme }) => theme.wsc.palette.neutral[700]};
  overflow: auto;
  max-height: 17.857rem;
  border-radius: ${({ theme }) => theme.wsc.radius.sm};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;
`;

export const StyledNoOptions = styled("li")`
  list-style: none;
  padding: ${({ theme }) => theme.wsc.spacing[1]};
  cursor: default;
  color: ${({ theme }) => theme.wsc.palette.neutral[200]};
`;
